<div mat-dialog-title>

  @if (step == 1) {
    <h1 class="titulo-simpli">Ingresa los datos de tu factura</h1>
  }
  @if (step == 1 && empty_facturas == false) {
    <small class="subtitulo-simpli">Completa todos los campos solicitados.</small>
  }

  @if (step == 2) {
    <h1 class="titulo-simpli">Resumen de las facturas agregadas </h1>
  }
  @if (step == 2 && empty_facturas == false) {
    <small class="subtitulo-simpli">Selecciónalas para ver toda la información.</small>
  }

</div>

<div mat-dialog-content [ngStyle]="is_responsive ? {'min-height': '85vh'} : {}">

  @if (step == 1) {
    <form  [formGroup]="valFormFilter" class="animate__animated animate__fadeIn">
      <mat-form-field appearance="fill">
        <mat-label>Número de factura</mat-label>
        <input matInput formControlName="folio" type="number" (change)="find_duplicates()"  (input)="limitInput($event); find_duplicates()" (blur)="find_duplicates()" >
        <mat-hint>Ingresa el número de la factura</mat-hint>
        @if (valFormFilter.controls['folio'].hasError('required')) {
          <mat-error>
            Este campo es <strong>obligatorio</strong>
          </mat-error>
        }
        @if (valFormFilter.controls['folio'].hasError('invalid')) {
          <mat-error>
            ¡Ups! Al parecer, esta factura ya existe
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>RUT</mat-label>
        <input type="text" matInput formControlName="rut" (change)="validate_rut()"  (keyup)="rut_key($event)" (keypress)="rutKeypress($event)">
        <mat-hint>Ingresa el RUT de la empresa deudora</mat-hint>
        @if (spinner_rut) {
          <mat-spinner matSuffix diameter="20" style="margin-right: 10px;"></mat-spinner>
        }
        @if (valFormFilter.controls['rut'].hasError('required')) {
          <mat-error>
            Este campo es <strong>obligatorio</strong>
          </mat-error>
        }
        @if (valFormFilter.controls['rut'].hasError('invalid')) {
          <mat-error>
            El RUT no es válido (verifícalo en la factura)
          </mat-error>
        }
        @if (!spinner_rut) {
          <mat-icon matSuffix matTooltip="Es el RUT de la empresa que debe realizar el pago de la factura (tu cliente)">
            info_outline
          </mat-icon>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Empresa deudora</mat-label>
        <input type="text" matInput formControlName="deudor">
        <mat-hint>Ingresa el nombre de la empresa</mat-hint>
        @if (valFormFilter.controls['deudor'].hasError('required')) {
          <mat-error>
            Este campo es <strong>obligatorio</strong>
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill"  (click)="picker.open()">
        <mat-label>Fecha emisión</mat-label>
        <input type="text" readonly matInput [matDatepicker]="picker" (dateChange)="change_date($event)" formControlName="fecha_emision_utc">
        <mat-hint>Ingresa la fecha de emisión de la factura</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (valFormFilter.controls['fecha_emision'].hasError('required')) {
          <mat-error>
            Este campo es <strong>obligatorio</strong>
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Monto factura</mat-label>
        <input matInput type="text" formControlName="monto" (keyup)="format_monto($event)">
        <mat-hint>Ingresa el monto total de la factura</mat-hint>
        @if (valFormFilter.controls['monto'].hasError('required')) {
          <mat-error>
            Este campo es <strong>obligatorio</strong>
          </mat-error>
        }
        @if (valFormFilter.controls['monto'].hasError('invalid')) {
          <mat-error>
            El monto debe ser mayor a 0
          </mat-error>
        }
      </mat-form-field>
      <div class="sep">
        <mat-label class="label-i">Monto total</mat-label>
        <mat-label class="label-d">${{montoformat}}</mat-label>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="btn-simpli-container">
            <button class="secondary-button" mat-dialog-close mat-flat-button>
              Cerrar
            </button>
            <button class="primary-button" [disabled]="loading_process" (click)="submitForm($event, valFormFilter.value)" mat-flat-button>
              @if (loading_process == false) {
                <span>Agregar factura</span>
              }
              @if (loading_process == true) {
                <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
              }
            </button>
          </div>
        </div>
      </div>
    </form>
  }

  @if (step == 2) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn">
      @if (empty_facturas == false) {
        <div class="container-exp add_factoring">
          <mat-accordion>
            @for (i of obs | async; track i) {
              <mat-expansion-panel  [expanded]="(i.errorReemitida != null)" [ngClass]="{'error-facturas': i.errorReemitida != null}"  style="margin-bottom: 15px;">
                <mat-expansion-panel-header style="position: relative;">
                  <mat-panel-title>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="c-exp">
                          <div class="l-exp-i"><input class="no-input l-exp-i error-label-noeditable" readonly value="N° Factura:"></div>
                          <div class="l-exp-d"><input class="no-input l-exp-d error-label-noeditable" readonly value="{{i.folio}}"></div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="c-exp">
                          <div class="l-exp-i"><input class="no-input l-exp-i error-label-noeditable" readonly value="Monto:"></div>
                          <div class="l-exp-d"><input class="no-input l-exp-d error-label-noeditable" readonly value="${{formatMoney(i.monto)}}"></div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="c-exp">
                          <div class="l-exp-i"><input class="no-input l-exp-i error-label-noeditable" readonly value="Deudor:"></div>
                          <div class="l-exp-d"><input class="no-input l-exp-d error-label-noeditable" readonly value="{{i.deudor}}"></div>
                        </div>
                      </div>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description class="exp-desc">
                    <div style="margin-top: 20px;margin-right: 10px;z-index: 999999999;" matTooltip="Eliminar factura" (click)="delete_factura(i.folio); $event.preventDefault();"><span class="material-symbols-outlined exp-delete">delete</span></div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row" style="margin-top: 20px;">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="c-exp">
                      <div class="l-exp-i"><input class="no-input l-exp-i" readonly value="RUT:"></div>
                      <div class="l-exp-d"><input class="no-input l-exp-d" readonly value="{{i.rut}}"></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="c-exp">
                      <div class="l-exp-i"><input class="no-input l-exp-i" readonly value="Fecha emisión:"></div>
                      <div class="l-exp-d"><input class="no-input l-exp-d" readonly value="{{i.fecha_emision}}"></div>
                    </div>
                    @if (error_reemitida == true) {
                      <div class="c-exp">
                        <div class="l-exp-i"><input class="no-input l-exp-i" readonly value="Error:"></div>
                        <div class="l-exp-d"><input class="no-input l-exp-d" readonly value="Esta factura no es de reemplazo."></div>
                      </div>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      }
      <div class="row">
        @if (facturas.length > 0) {
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="text-align: center;">
            <mat-paginator [pageSizeOptions]="[6, 12, 24]"></mat-paginator>
          </div>
        }
      </div>
      @if (empty_facturas == false) {
        <div class="sep">
          <mat-label class="label-i">Monto total</mat-label>
          <mat-label class="label-d">${{formatMoney(monto_total)}}</mat-label>
        </div>
      }
      @if (empty_facturas == true) {
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <div class="c-simpli">
              <div style="text-align: center;margin-bottom: 30px;">
                <span class="material-symbols-outlined i-simpli">warning</span>
              </div>
              <div class="l-simpli">
                Debes agregar por lo menos 1 factura
              </div>
              <div class="l-simpli">
                para realizar la simulación
              </div>
            </div>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
          <div [ngClass]="{'btn-simpli-container':true}">
            @if (open_as_dialog == false && reemitida_mode == false) {
              <button [disabled]="empty_facturas == true"  mat-flat-button [ngClass]="{'primary-button':true}" (click)="go_to_simular()">
                Iniciar simulación
              </button>
            }
            @if (open_as_dialog == true && reemitida_mode == false) {
              <button  mat-flat-button [ngClass]="{'primary-button':true}" (click)="go_to_simular()">
                Continuar
              </button>
            }
            @if (reemitida_mode == true) {
              <button [disabled]="error_reemitida"  mat-flat-button [ngClass]="{'primary-button':true, 'disabled_btn':error_reemitida == true}" (click)="go_to_simular()">
                Continuar
              </button>
            }
            <button  mat-flat-button (click)="add_mas_facturas()" [ngClass]="{'secondary-button':true}">
              Agregar más facturas
            </button>
          </div>
        </div>
      </div>
    </div>
  }

</div>